/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiTaxDeclarationInitializeDocumentPost$Plain$Params {
  
    /**
     * Multipart form data. The tax year plus the prior-year declaration document to prefill from.
     */
    body: {

/**
 * Tax year the new declaration is created for.
 */
'year': number;

/**
 * The prior-year tax-declaration document. The AI pipeline extracts and prefills the new declaration from it.
 */
'file': Blob;
}
}

export function apiTaxDeclarationInitializeDocumentPost$Plain(http: HttpClient, rootUrl: string, params: ApiTaxDeclarationInitializeDocumentPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, apiTaxDeclarationInitializeDocumentPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

apiTaxDeclarationInitializeDocumentPost$Plain.PATH = '/api/TaxDeclaration/initialize-document';
